import React from "react";

export const RoleUser = {
    ROLE_MASTER: "ROLE_MASTER",
    ROLE_ADMIN: "ROLE_ADMIN"
}

export const appLocalStorage = {
    TOKEN: 'token',
    TOKENNODE: 'tokennode',
    USER: 'user',
    STORE: 'store',
    CUSTOMER: 'customer',
    CUSTOMER_BOOK: 'customer_book'
}


export const appRoutePath = {
    Dashboard: "/home",
    InboxPage: "/inbox",
    LoginPage: "/login",
    FeedbackPage: "/feedback",
    AppointmentAdminPage: "/appointment-admin",
    AppointmentBook: "/appointment-book",
    CheckInPage: "/checkin",
    CheckInDetailPage: "/checkin/id",
    MessageSend: "/message/send",
    MessagePresets: "/message/presets",
    MessageWelcome: "/message/welcome",
    MessageTemplete: "/message/templete",
    MessageReport: "/message/report",

    CustomerPage: "/customer-l",
    CustomerDetailPage: "/customer",

    CustomerGroupPage: "/customer-group-l",
    CustomerGroupDetailPage: "/customer-group",

    ServicePage: "/services",
    ServiceDetailPage: "/services",
    PromoPage: "/promos",
    PromoDetailPage: "/promos",
    ShortUrl: "/config-shorturl",
    StoreConfigPage: "/config-store",
    HostedWidgetPage: "/config-hosted-widget",
    SocialMediaPage: "/config-social-media",
    StaffPage: "/staffs",
    StaffDetailPage: "/staffs",
    StorePage: "/stores",
    StoreDetailPage: "/stores",
    MyStorePage: "/mystore",
    UserPage: "/users",
    UserDetailPage: "/users",
    ImagePage: "/images",
    Error404: "/error-404",
    Error500: "/error-500",
    BlankPage: "/blank-page"
};

export const MessageConfig = {
    MAX_LENGTH: 160,
    MAX_LENGTH_SUBJECT: 50
}


export const ScheduleType = {
    SEND_NOW: 'now',
    SEND_LATER: 'later',
    SEND_DRIP: 'drip',
    EVENTS: 'events',
    RECURRING: 'recurring',
    WELCOME: 'welcome',
}

export const EventsType = {
    EVENT_CHECKIN: 'checkin',
    EVENT_CHECKIN_LABEL: 'Checkin',

    EVENT_BIRTHDAY: 'birthday',
    EVENT_BIRTHDAY_LABEL: 'Birthday',

    EVENT_APM_CONFIRM: 'apm_confirm',
    EVENT_APM_CONFIRM_LABEL: 'Apointment-confirm',

    EVENT_APM_REJECT: 'apm_reject',
    EVENT_APM_REJECT_LABEL: 'Apointment-reject'
}

export const WelcomeStep = {STEP1: 'step_1', STEP2: 'step_2'}

export const MethodSend = {
    SEND_SMS: 'SMS',
    SEND_MMS: 'MMS'
}

export const MessageStatus = {
    NEW: 0
}

export const MessageDetailType = {
    ITEM_GROUP: 'group',
    ITEM_IMAGE: 'image',
    ITEM_PHONE: 'phone'
}

export const DelayHours = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

export const GMT = { PST: -8, PT: -7, MT: -6, CT: -5, ET: -4, HAT: -10}

export const TimeZoneValue = [
    {
        name: 'PST (UTC -8)', /** Pacific Standard Time */
        gmt: -8
    },
    {
        name: 'PT (UTC -7)', /** Pacific Time */
        gmt: -7
    },
    {
        name: 'MT (UTC -6)', /** Mountain Time */
        gmt: -6
    },
    {
        name: 'CT (UTC -5)', /** Central Time */
        gmt: -5
    },
    {
        name: 'ET (UTC -4)', /** Eastern Time */
        gmt: -4
    },
    {
        name: 'HAT (UTC -10)', /** Pacific Standard Time */
        gmt: -10
    }
];

export const RANGE_DAYS = [
    { name: 'Today', val: '0-0'},
    { name: 'Yesterday', val: '1-1'},
    { name: 'Last 2 Days', val: '0-2'},
    { name: 'Last 3 Days', val: '0-3'},
    { name: 'Last 7 Days', val: '0-7'},
    { name: 'Last 30 Days', val: '0-30'},
    { name: 'Last 31-60 Days', val: '31-60'},
    { name: 'Last 61-90 Days', val: '61-90'},
    { name: 'Last 91-120 Days', val: '91-120'},
    { name: 'Last 121-150 Days', val: '121-150'},
    { name: 'Last 151-180 Days', val: '151-180'}
];

export const GENDER = [{ name: 'Male', val: 'Male'}, { name: 'Female', val: 'Female'}];

export const UNIT_PROMO = [{name: 'Point', val: 'Point'}, {name: 'Percent', val: 'Percent'}, {name: 'Dollars', val: 'Dollars'}];

export const SequenceMM = () => {
    return Array.from(new Array(60)).map((element, index) => index);
}

export const SequenceHH = () => {
    return Array.from(new Array(24)).map((element, index) => index);
}

export const AppConst = {
    EventsType,
    ScheduleType,
    MessageDetailType,
    MessageConfig,
    MethodSend,
    DelayHours,
    appRoutePath,
    RoleUser
}
